import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginRequestModel, LoginResponseModel } from '../../../app/models/login.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UsuarioConsultaRequestModel, UsuarioConsultaResponseModel, UsuarioExcluirResponseModel, UsuarioReenviarEmailResponseModel, UsuarioCadastroRequestModel, UsuarioCadastroResponseModel, UsuarioReenviarEmailRequestModel, UsuarioExcluirRequestModel, UsuarioObterResponseModel, UsuarioCadastroAssociadosRequestModel } from '../../../app/models/usuario.model';
import { EsqueciSenhaRequest } from 'src/app/models/esqueci-minha-senha.model';
import { CadastroSenhaRequest, CadastroSenhaResponseModel } from 'src/app/models/cadastro-senha.model';
import { MenuModel } from 'src/app/models/perfil.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  public headers: Headers = new Headers();

  constructor(private http: HttpClient) { }

  login(request: LoginRequestModel): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(`${environment.apiUrlControleDeAcesso}/login-backoffice`, request);
  }

  listar(request: UsuarioConsultaRequestModel): Observable<UsuarioConsultaResponseModel> {
    return this.http.post<UsuarioConsultaResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/buscar`, request);
  }

  adicionar(request: UsuarioCadastroRequestModel): Observable<UsuarioCadastroResponseModel> {
    return this.http.post<UsuarioCadastroResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/adicionar`, request);
  }

  adicionarAssociado(request: UsuarioCadastroAssociadosRequestModel): Observable<any> {
    return this.http.post<UsuarioCadastroAssociadosRequestModel>(`${environment.apiUrlControleDeAcesso}/usuario/adicionar`, request);
  }

  obter(id): Observable<UsuarioObterResponseModel> {
    return this.http.get<UsuarioObterResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/obter/${id}`);
  }

  editar(id: number, request: UsuarioCadastroRequestModel): Observable<UsuarioCadastroResponseModel> {
    return this.http.put<UsuarioCadastroResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/editar/${id}`, request);
  }

  excluir(request: UsuarioExcluirRequestModel): Observable<UsuarioExcluirResponseModel> {
    return this.http.post<UsuarioExcluirResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/excluir`, request);
  }

  ativar(request: UsuarioExcluirRequestModel): Observable<UsuarioExcluirResponseModel> {
    return this.http.post<UsuarioExcluirResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/ativar`, request);
  }

  reenviarEmail(request: UsuarioReenviarEmailRequestModel) {
    return this.http.post(`${environment.apiUrlControleDeAcesso}/usuario/reenviar-email`, request);
  }

  reenviarEmailLote(request: UsuarioReenviarEmailRequestModel[]) {
    return this.http.post(`${environment.apiUrlControleDeAcesso}/usuario/reenviar-email-lote`, request);
  }

  esqueciSenha(request: EsqueciSenhaRequest): Observable<UsuarioExcluirResponseModel> {
    return this.http.post<UsuarioReenviarEmailResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/esqueci-senha`, request);
  }

  cadastrarSenha(request: CadastroSenhaRequest): Observable<CadastroSenhaResponseModel> {
    return this.http.post<CadastroSenhaResponseModel>(`${environment.apiUrlControleDeAcesso}/usuario/cadastrar-senha`, request);
  }

  perfil(): Observable<MenuModel> {
    var perfilInfo = localStorage.getItem('perfil');
    if (!perfilInfo) {
     return this.http.get<MenuModel>(`${environment.apiUrlControleDeAcesso}/usuario/perfil`)
        .pipe(
          map<MenuModel,MenuModel>(x => {
            localStorage.setItem('perfil',JSON.stringify(x));
            return x;
          })
        );
    } else {
      return new Observable<MenuModel>((x) => {
        x.next(<MenuModel>JSON.parse(perfilInfo));
      });
    }
  }

  validarTokenRedefinicaoSenha(token: string) {
    return this.http.get(`${environment.apiUrlControleDeAcesso}/usuario/validar-token-redefinicao/${token}`)
  }
}
